// extracted by mini-css-extract-plugin
export var tosLink = "_4i-0";